import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/62_card_back_gift/62_card_back_gift"
 * Contains 1 texture(s)
 */
export class CardsBacks62CardBackGiftAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/62_card_back_gift/62_card_back_gift';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '62_gift.png'
    ] as const;
}
